/**
 * Checks if the phoneNumber provided is valid.
 * A list of valid phone numbers can be viewed here: https://regex101.com/r/DsaRfI/1.
 * */
export const isPhoneNumberValid = (phoneNumber: string) => {
  const regex = RegExp(
    '^(\\+\\d{1,2}\\s?)?1?\\-?\\.?\\s?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$'
  );
  return regex.test(phoneNumber);
};

/**
 * Converts phone number to E164 format.
 * */
export const phoneNumberToE164 = (phoneNumber: string) => {
  const numsOnly = phoneNumber.replace(/\D/g, '');
  if (numsOnly.length === 10) {
    return `+1${numsOnly}`;
  }
  return `+${numsOnly}`;
};
